export default "__VITE_ASSET__DcEc_sIq__"